import { createSlice } from '@reduxjs/toolkit'
import { ARM_TTL_MS } from './spotlight'

/**
 * The one spotlight the assistant has asked for and the viewer has agreed
 * to by clicking its card: `pending = {anchor, tip, requires?, parent?,
 * path, fromKey?, expiresAt}`. `AssistSpotlight` (mounted once in RootLayout)
 * picks it up once the route reaches `path`, and clears it when the ring
 * appears, when the anchor never shows, when the route lands somewhere other
 * than `path` (a redirect), or when it expires on the way. `fromKey` is the
 * router location key the card was clicked on, so "not moved yet" can be
 * told apart from "sent elsewhere"; `path: null` waits on whatever page is
 * current.
 */
const initialState = { pending: null }

const assistSlice = createSlice({
  name: 'assist',
  initialState,
  reducers: {
    armSpotlight: {
      reducer(state, action) {
        state.pending = action.payload
      },
      prepare({ anchor, tip = '', requires, parent, path, fromKey }) {
        return {
          payload: {
            anchor, tip, path, expiresAt: Date.now() + ARM_TTL_MS,
            ...(requires ? { requires } : {}),
            ...(parent ? { parent } : {}),
            ...(typeof fromKey === 'string' ? { fromKey } : {}),
          },
        }
      },
    },
    clearSpotlight(state) {
      state.pending = null
    },
  },
})

export const { armSpotlight, clearSpotlight } = assistSlice.actions
export const selectPendingSpotlight = (state) => state.assist?.pending ?? null
export default assistSlice.reducer
